
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 30 30"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"fill":"none","stroke":"currentColor","stroke-linecap":"round","stroke-linejoin":"round"}},[_c('path',{attrs:{"stroke-width":"1.6","d":"M5 27.19V2.81h15l5 5v19.38H5z"}}),_c('g',{attrs:{"stroke-width":"1.2"}},[_c('path',{attrs:{"d":"M11.33 11.25l7.34 9.37M16.67 20.62H20M10 11.25h3.33"}}),_c('g',[_c('path',{attrs:{"d":"M18.67 11.25l-7.34 9.37M13.33 20.62H10M20 11.25h-3.33"}})])])])])
          )
        }
      }
    